/** One shared Google Maps loader — every map/autocomplete must use the same options or the Loader throws. */
import { Loader } from '@googlemaps/js-api-loader';

const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
let loading = null;

export function loadGoogleMaps() {
  if (!MAPS_KEY) return Promise.reject(new Error('Google Maps is not configured'));
  if (!loading) {
    loading = new Loader({ apiKey: MAPS_KEY, version: 'weekly', libraries: ['places', 'geometry'] }).load()
      .catch((e) => { loading = null; throw e; });  // a network blip must not break maps until reload
  }
  return loading;
}
